export const ProgressBar = ({ show, progress, failed }) => {
    const waiting = progress === 0;

    return(
        <div className={`progress-bar-wrapper tif-px-10 overflow-hidden ${ show ? "show" : "" } ${ failed ? "failed" : "" }`}>
            {
                waiting && <p>Waiting...</p>
            }
            {
                !waiting && !failed && progress !== 100 && 
                    <p>
                        { progress <= 49 && "Uploading files to the server..." }
                        { progress > 49 && "Uploading data to the vector database..." }
                    </p>
            }
            {
                !waiting && !failed && progress === 100 && <p>Complete</p>
            }
            {
                !waiting && failed && <p>Failed</p>
            }
            <div className="progress-fill" style={{ width: `${ progress }%` }}></div>
        </div>
    );
};